module.exports = __webpack_public_path__ + "img/znch.79ddcb5.png";